import { useEffect, useState } from "react";

export function useFacetAutogenerateCountdown(
  active: boolean,
  startSeconds: number
): number {
  const [remaining, setRemaining] = useState(startSeconds);

  useEffect(() => {
    if (!active) {
      setRemaining(startSeconds);
      return;
    }
    const interval = window.setInterval(() => {
      setRemaining((value) => Math.max(0, value - 1));
    }, 1000);
    return () => window.clearInterval(interval);
  }, [active, startSeconds]);

  return remaining;
}
